export const ACCOUNT_GROUPED_GOS_CERTIFICATES_FETCH =
  'ACCOUNT_GROUPED_GOS_CERTIFICATES_FETCH';
